import { inject } from '@angular/core';
import { Routes, Router } from '@angular/router';
import { CKAuthGuard, CKGuestGuard, CKAuthService } from '@ck-core/ck-auth';
import { unsavedChangesGuard } from './shared/unsaved-changes/unsaved-changes.guard';
import { UserRoleEnum } from './models/users/user.model';
import { getRolesList } from './shared/components/header/header';

export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () => import('./pages/auth/login/login').then((m) => m.LoginPage),
        canActivate: [CKGuestGuard],
        data: { layout: 'none', title: 'Login' },
    },
    {
        path: 'forgot-password',
        loadComponent: () =>
            import('./pages/auth/forgot-password/forgot-password').then(
                (m) => m.ForgotPasswordPage,
            ),
        canActivate: [CKGuestGuard],
        data: { layout: 'none', title: 'Forgot Password' },
    },
    {
        path: 'verify',
        loadComponent: () => import('./pages/auth/verify/verify').then((m) => m.VerifyPage),
        canActivate: [CKGuestGuard],
        data: { layout: 'none', title: 'Verify Email' },
    },
    {
        path: 'reset-password',
        loadComponent: () =>
            import('./pages/auth/reset-password/reset-password').then((m) => m.ResetPasswordPage),
        canActivate: [CKGuestGuard],
        data: { layout: 'none', title: 'Reset Password' },
    },
    {
        path: 'create-password',
        loadComponent: () =>
            import('./pages/auth/create-password/create-password').then((m) => m.CreatePasswordPage),
        canActivate: [CKGuestGuard],
        data: { layout: 'none', title: 'Create Password' },
    },
    {
        path: 'update-details',
        loadComponent: () =>
            import('./pages/auth/update-details/update-details').then((m) => m.UpdateDetailsPage),
        canActivate: [CKGuestGuard],
        data: { layout: 'none', title: 'Update Details' },
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'blanks',
    },
    {
        path: 'blanks',
        canActivate: [CKAuthGuard],
        loadComponent: () => import('./pages/blanks/blanks').then((m) => m.Blanks),
        data: { title: 'Blanks' },
    },
    {
        path: 'users',
        canActivate: [
            CKAuthGuard,
            () => {
                const auth = inject(CKAuthService);
                const router = inject(Router);
                const rawRole = auth.authData?.role;
                const roles = getRolesList(rawRole);
                const isMimic = auth.authData?.moreInfo?.isMimic;
                if (
                    roles.includes(UserRoleEnum.ExecutiveAdmin) ||
                    roles.includes('Executive Admin') ||
                    roles.includes(UserRoleEnum.SaasAdmin) ||
                    roles.includes('Saas Admin')
                ) {
                    return true;
                }
                router.navigateByUrl('/blanks');
                return false;
            },
        ],
        loadComponent: () => import('./pages/users/users').then((m) => m.Users),
        data: { title: 'Users' },
    },
    {
        path: 'settings',
        canActivate: [
            CKAuthGuard,
            () => {
                const auth = inject(CKAuthService);
                const router = inject(Router);
                const rawRole = auth.authData?.role;
                const roles = getRolesList(rawRole);
                const isMimic = auth.authData?.moreInfo?.isMimic;
                if (
                    roles.includes(UserRoleEnum.ExecutiveAdmin) ||
                    roles.includes('Executive Admin') ||
                    roles.includes(UserRoleEnum.OperationalAdmin) ||
                    roles.includes('Operational Admin') ||
                    roles.includes(UserRoleEnum.SaasAdmin) ||
                    roles.includes('Saas Admin')
                ) {
                    return true;
                }
                router.navigateByUrl('/blanks');
                return false;
            },
        ],
        loadComponent: () => import('./pages/settings/settings').then((m) => m.Settings),
        data: { title: 'Settings' },
        loadChildren: () =>
            import('./pages/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
    },
    {
        path: 'mimic',
        loadComponent: () =>
            import('./pages/auth/mimic/mimic.component').then((m) => m.MimicComponent),
        data: { layout: 'none', title: 'Mimic', index: 0 },
    },
    {
        path: 'job-form',
        canActivate: [CKAuthGuard],
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () => import('./pages/job-form/job-form').then((m) => m.JobFormPage),
        data: { title: 'Job Form' },
    },
    {
        path: 'job-form/:id',
        canActivate: [CKAuthGuard],
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () => import('./pages/job-form/job-form').then((m) => m.JobFormPage),
        data: { title: 'Job Form' },
    },
    {
        path: 'job-form/view/:id',
        loadComponent: () =>
            import('./pages/job-form/components/job-form-view/job-form-view.component').then(
                (m) => m.JobFormViewComponent,
            ),
        data: {layout: 'none', title: 'Job Form View' },
    },
    {
        path: 'job-form/pdf-view/:id',
        loadComponent: () =>
            import('./pages/job-form/components/job-form-view/job-form-view.component').then(
                (m) => m.JobFormViewComponent,
            ),
        data: {layout: 'none', title: 'Job PDF View' },
    },
    { path: '**', redirectTo: 'login' },
];
